<ng-container *ngIf="vm$ | async as vm">
<h2 class="head2">Notities</h2>
<div class="c2-notities-rowmaincontent">
  <div class="c2-notitie-rowitem" *ngFor="let notitie of vm.notities trackBy:getNotitieId">
    <div class="c2-user-info">

      <div class="userinfo-leftpanel">
        <div class="c2-user-info-icon">
          <i aria-hidden="true" class="icon-notities-dots"></i>
        </div>
        <div class="c2-user-info-detail">
          <span class="c2-notitie-afzender">{{notitie.Afzender}}</span>
          <span class="c2-notitie-date">{{notitie.DatumUpdate | date : 'd/M/yyyy'}}</span>
        </div>
      </div>
      <div class="userinfo-rightpanel">
        <div class="c2-notitie-read">
          <span class="c2-notitie-close">
            <button type="button" aria-label="Markeer notitie gelezen" (click)="notitieGelezenSubj.next(notitie)" class="btn-icon-light icon-disagree"></button>
          </span>
        </div>
      </div>
    </div>

    <a tabindex="0" (click)="navigateToAgendapunt(notitie)" class="c2-notitie-inhoud c2-clickable">{{notitie.Inhoud}}</a>
  </div>
</div>
<div class="c2-footer">
  <button role="link" aria-label="Zoek scherm notities" [routerLink]="['/notities/zoeken']" (click)="close()" class="btn btn-default">Zoeken...</button>
  <button aria-label="Meer notities laden" *ngIf="vm.hasMoreResults" (click)="meerNotitiesSubj.next(vm.page+1)" class="btn btn-default">Meer...</button>
</div>
</ng-container>